import React from "react";
import { Segment, Image, Grid, Icon, Button, Label } from "semantic-ui-react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

function bytesToSize(bytes) {
	var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
	if (bytes == 0) return "0 Byte";
	var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
	return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

class HiCropper extends React.Component {
	state = {
		ar: "free",
	};

	cropImage = () => {
		if (typeof this.cropper.getCroppedCanvas() === "undefined") {
			return;
		}
		const uri = this.cropper.getCroppedCanvas().toDataURL();
		this.downloadFile(uri, this.props.photo.name);
	};

	downloadFile = (uri, name) => {
		var link = document.createElement("a");
		link.download = name;
		link.href = uri;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	justDraw = () => {
		if (typeof this.cropper.getCroppedCanvas() === "undefined") {
			return;
		}
		console.log("Just Draew");
		const canvas = this.cropper.getCroppedCanvas();
		const croppedImg = canvas.toDataURL();
		this.props.onCrop({
			src: croppedImg,
			width: canvas.width,
			height: canvas.height,
		});
	};

	render() {
		if (!this.props.photo) {
			return null;
		}

		const photo = this.props.photo;

		return (
			<Grid columns={2} padded="vertically">
				<Grid.Column>
					<div style={{ position: "relative" }}>
						<Button
							icon
							labelPosition="left"
							primary={this.state.ar === "square"}
							onClick={() => this.setState({ ar: "square" })}
						>
							Square
							<Icon name="square outline" />
						</Button>
						<Button
							icon
							labelPosition="left"
							primary={this.state.ar === "free"}
							onClick={() => this.setState({ ar: "free" })}
						>
							Free
							<Icon name="crop" />
						</Button>
						<Button
							icon
							labelPosition="left"
							primary={this.state.ar === "free"}
							onClick={this.justDraw}
						>
							Apply
							<Icon name="pencil" />
						</Button>
						<Label
							basic
							color="black"
							size="large"
							style={{
								position: "absolute",
								bottom: "0px",
								right: "0px",
							}}
						>
							{bytesToSize(photo.size)}
						</Label>
					</div>
					<div style={{ height: "10px" }} />
					<Cropper
						ref={(cropper) => {
							this.cropper = cropper;
						}}
						src={photo.src}
						style={{ width: "100%", height: 400 }}
						viewMode={1}
						preview=".img-preview"
						aspectRatio={this.state.ar === "square" ? 1 / 1 : null}
						guides={true}
						movable={false}
						zoomable={false}
						// cropBoxResizable={true}
					/>
				</Grid.Column>
				<Grid.Column>
					<Button
						icon
						labelPosition="left"
						positive
						onClick={this.cropImage}
					>
						Download
						<Icon name="download" />
					</Button>
					<div style={{ height: "10px" }} />
					<div
						className="img-preview"
						style={{
							width: "100%",
							height: 400,
							textAlign: "center",
							overflow: "hidden",
							border: "1px solid grey",
						}}
						onLoad={() => {
							console.log("Loaded.");
						}}
					/>
				</Grid.Column>
			</Grid>
		);
	}
}

export default HiCropper;
